import React from "react";
import { Bike, MapPin } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import Reveal from "./Reveal";

const IMG = "/api/files/begaudiere/uploads/a3b1f99f-89e3-4313-a2b4-0a366b0be2e6.png";

export const BikeRental = ({ dark = false }) => {
  const { t } = useI18n();
  const priceCard = (label, half, full) => (
    <div className="rounded-2xl bg-white border border-black/5 p-4">
      <div className="flex items-center gap-2 mb-2">
        <Bike size={16} className="text-brand" />
        <p className="font-body text-sm text-ink-700">{label}</p>
      </div>
      <div className="flex items-baseline gap-4">
        <div><span className="font-heading text-2xl text-brand">{half}</span><span className="text-xs text-ink-400 ml-1">/ {t("bikeRental.halfDay")}</span></div>
        <div><span className="font-heading text-2xl text-brand">{full}</span><span className="text-xs text-ink-400 ml-1">/ {t("bikeRental.fullDay")}</span></div>
      </div>
    </div>
  );
  return (
    <section className={`py-20 lg:py-28 ${dark ? "bg-beige/60" : ""}`} data-testid="bike-rental">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal className="relative">
          <div className="rounded-3xl overflow-hidden aspect-[4/3] shadow-[0_20px_60px_rgba(44,48,48,0.12)]">
            <img src={IMG} alt={t("bikeRental.title")} loading="lazy" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-5 -right-3 sm:right-6 rounded-2xl bg-brand text-white px-5 py-3 flex items-center gap-2.5 shadow-lg">
            <Bike size={20} strokeWidth={1.75} />
            <span className="font-heading text-lg">{t("bikeRental.tag")}</span>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <p className="text-brand font-accent text-2xl italic mb-3">{t("bikeRental.tag")}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-ink-900 mb-5">{t("bikeRental.title")}</h2>
          <p className="text-ink-600 font-body leading-relaxed mb-6">{t("bikeRental.text")}</p>
          <div className="grid sm:grid-cols-2 gap-4 mb-6">
            {priceCard(t("bikeRental.adult"), t("bikeRental.adultHalf"), t("bikeRental.adultFull"))}
            {priceCard(t("bikeRental.child"), t("bikeRental.childHalf"), t("bikeRental.childFull"))}
          </div>
          <p className="inline-flex items-center gap-2 rounded-full bg-beige px-4 py-2 text-sm text-ink-600">
            <MapPin size={15} className="text-brand" /> {t("bikeRental.note")}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
